import list from 'src/modules/objetivo/list/objetivoListReducers';
import form from 'src/modules/objetivo/form/objetivoFormReducers';
import view from 'src/modules/objetivo/view/objetivoViewReducers';
import destroy from 'src/modules/objetivo/destroy/objetivoDestroyReducers';
import importerReducer from 'src/modules/objetivo/importer/objetivoImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
